export const localToken = localStorage.getItem('from_client_local_token');
export const authRoute = process.env.REACT_APP_AUTH_ROUTE;
export const backURI = process.env.REACT_APP_BACK_URI;
export const apiServerURI = process.env.REACT_APP_VECTOR_SERVER_URI;
export const proxyURI = process.env.REACT_APP_PROXY_ROUTE;

export const occupationOptions = [
  { id: 'production', title: 'Production', faIcon: 'fa-solid fa-user-tie' },
  { id: 'marketing', title: 'Marketing', faIcon: 'fa-solid fa-comments-dollar' },
  { id: 'visualArt', title: 'Visual art', faIcon: 'fa-solid fa-masks-theater' },
  { id: 'graphicDesign', title: 'Graphic design', faIcon: 'fa-solid fa-icons' },
  { id: 'photography', title: 'Photography', faIcon: 'fa-solid fa-camera-retro' },
  { id: 'artisticManagement', title: 'Artistic Management', faIcon: 'fa-solid fa-stamp' },
  { id: 'soundAndAmplification', title: 'Sound and Amplification', faIcon: 'fa-solid fa-headphones' },
  { id: 'projectManagement', title: 'Project Management', faIcon: 'fa-solid fa-list-check' },
  { id: 'music', title: 'Music', faIcon: 'fa-solid fa-music' },
  { id: 'writing', title: 'Writing', faIcon: 'fa-solid fa-paragraph' },
  { id: 'lighting', title: 'Lighting', faIcon: 'fa-regular fa-lightbulb' },
  { id: 'programming', title: 'Programming', faIcon: 'fa-solid fa-code' },
];

export const sqlComparisonOperators = [
  '=', // Equal to
  '<>', // Not equal to (alternative: !=)
  '!=', // Not equal to
  '>', // Greater than
  '<', // Less than
  '>=', // Greater than or equal to
  '<=', // Less than or equal to
  'LIKE', // Pattern matching
  'NOT LIKE', // Negated pattern matching
  'IN', // Matches any value in a list
  'NOT IN', // Does not match any value in a list
  'BETWEEN', // Within a range
  'NOT BETWEEN', // Not within a range
  'IS NULL', // Checks for null values
  'IS NOT NULL', // Checks for non-null values
];

export const variableTypes = ['FROM_RANGE_QUERY', 'FROM_VARIABLES'];

export const exampleCampaign = {
  id: '120206875118270526',
  name: 'Test Adbuzz 1 | CBO_ Dynamic-18plus-HV-FB_IG_2ADs | 2024-02-22T17:58:58.371Z | 1',
  account_id: '842117447457126',
  status: 'PAUSED',
  effective_status: 'PAUSED',
  objective: 'OUTCOME_SALES',
  start_time: '2024-02-22T18:58:59+0100',
  created_time: '2024-02-22T18:58:58+0100',
  updated_time: '2024-02-22T18:58:58+0100',
  budget_remaining: '2000',
  daily_budget: '2000',
  source_campaign_id: '0',
  bid_strategy: 'LOWEST_COST_WITHOUT_CAP',
  pacing_type: ['standard'],
  special_ad_category: 'HOUSING',
  special_ad_categories: ['HOUSING'],
  topline_id: '0',
  is_skadnetwork_attribution: false,
};

export const campaignObjectives = [
  'OUTCOME_LEADS',
  'OUTCOME_SALES',
  'OUTCOME_ENGAGEMENT',
  'OUTCOME_AWARENESS',
  'OUTCOME_TRAFFIC',
  'OUTCOME_APP_PROMOTION',
  // 'APP_INSTALLS',
  // 'BRAND_AWARENESS',
  // 'CONVERSIONS',
  // 'ENGAGEMENT',
  // 'LEAD_GENERATION',
  // 'LINK_CLICKS',
  // 'MESSAGES',
  // 'POST_ENGAGEMENT',
  // 'PRODUCT_CATALOG_SALES',
  // 'REACH',
  // 'STORE_VISITS',
  // 'TRAFFIC',
  // 'VIDEO_VIEWS',
];
